import {z} from 'zod';
import {UserSchema} from '#common/users/types';

export const EditUserFormSchema = UserSchema.extend({
  localeMode: z.enum(['auto', 'manual']),
  manualLocale: z.string().optional(),
});

export type EditUserFormValues = z.infer<typeof EditUserFormSchema>;

export function useEditUserSchema() {
  return EditUserFormSchema;
}
